export const AUTO_GENERATE_MESSAGES = {
    TESTCASES: `<b> Auto Generated Test Case{{caseText}}</b> will be added to the project. Please leave feedback on the Auto Generated results. This will significantly help us in improving the quality of the generated results.`,
    TESTCASES_APP_STEPS: `<b> Auto Generated Test Case{{caseText}} and Application Steps together</b> will be added to the project. Please leave feedback on the Auto Generated results. This will significantly help us in improving the quality of the generated results.`,
    FEEDBACK_MSG:
        'Please leave feedback on the Auto Generated results. This will significantly help us in improving the quality of the generated results.',
    THANK_YOU_MSG: 'Thank you for your feedback! Feedback sent successfully.',
    SUCCESS_MSG: {
        TESTCASES: 'Auto Generated Test Case{{caseText}} {{verbText}} been successfully added to the project.',
        TEST_SCENARIOS: 'Auto-generated Content have been successfully added to the test scenario.',
        APP_STEPS: 'Auto Generated App Steps have been successfully added to the testcase.',
    },
    ITEM_TYPE: {
        TESTCASES: 'TEST_CASES',
        TEST_SCENARIOS: 'TEST_SCENARIOS',
        APP_STEPS: 'APPLICATION_STEPS',
        APP_STEPS_FOR_MANUAL_TEST: 'APPLICATION_STEPS_FOR_MANUAL_TEST',
        APP_FIELDS: 'APPLICATION_FIELDS_FOR_AUTOGENERATED_TESTS',
        APP_FIELDS_FOR_MANUAL_TEST:'APPLICATION_FIELDS_FOR_MANUAL_TEST',
        TESTCASES_AND_APPSTEPS: 'TEST_CASES_AND_APPLICATION_STEPS',
        APP_STEPS_AUTOGEN: 'APPLICATION_STEPS_FOR_AUTOGENERATED_TESTS',
    },
    TOOLTIP: {
        TESTCASES:
            'Save and send feedback of the selected auto-generated Test Cases',
        TEST_SCENARIOS: 'Save and send feedback of the auto-generated content',
        APP_STEPS:
            'Save and send feedback of the selected auto-generated App steps',
        APP_FIELDS:
            'Save and send feedback of the selected auto-generated Application fields',
    },
    ERROR_MSG: 'Error submitting feedback: ',
    BUTTON_ACTIONS: {
        CANCEL: 'cancel',
        SAVE: 'save',
        BACK: 'back'
    },
    RATING_LABELS: {
        OPTIONAL: 'Optional',
        MANDATORY: 'Mandatory'
    }
};
export const INFO_DESCRIPTION = `Select a value to evaluate the output generation.<br/> A value of 0% is absolutely not a relevant result, and 100% is a highly relevant result. Values less than 50% must be accompanied by a comment.`;
export const RATING_OPTIONS = [
    { id: 'scale-0', name: 'scale0', value: 0 },
    { id: 'scale-10', name: 'scale10', value: 10 },
    { id: 'scale-20', name: 'scale20', value: 20 },
    { id: 'scale-30', name: 'scale30', value: 30 },
    { id: 'scale-40', name: 'scale40', value: 40 },
    { id: 'scale-50', name: 'scale50', value: 50 },
    { id: 'scale-60', name: 'scale60', value: 60 },
    { id: 'scale-70', name: 'scale70', value: 70 },
    { id: 'scale-80', name: 'scale80', value: 80 },
    { id: 'scale-90', name: 'scale90', value: 90 },
    { id: 'scale-100', name: 'scale100', value: 100 },
];